import { ExternalLink, FileText, Gamepad2 } from 'lucide-react'
import './Studio21Home.css'

const Studio21Home = () => {
  return (
    <div className="studio21-home">
      <div className="studio21-container">
        <header className="studio21-header">
          <h1 className="studio21-title">Studio 21 Games</h1>
          <p className="studio21-subtitle">Professional Game Development & Tools</p>
        </header>

        <div className="studio21-links">
          <a
            href="/plugins/VariableModding"
            className="studio21-card"
          >
            <div className="card-icon">
              <FileText size={48} />
            </div>
            <h2 className="card-title">Variable Modding System</h2>
            <p className="card-description">
              Complete documentation for our powerful Unreal Engine plugin for variable management and CSV-based data systems.
            </p>
            <span className="card-link-text">
              View Documentation <ExternalLink size={16} />
            </span>
          </a>

          <a
            href="https://playfragments.com"
            target="_blank"
            rel="noopener noreferrer"
            className="studio21-card"
          >
            <div className="card-icon">
              <Gamepad2 size={48} />
            </div>
            <h2 className="card-title">Fragments</h2>
            <p className="card-description">
              Experience our flagship game. Explore, build, and survive in a dynamic world powered by our cutting-edge technology.
            </p>
            <span className="card-link-text">
              Play Now <ExternalLink size={16} />
            </span>
          </a>
        </div>

        <footer className="studio21-footer">
          <p>© 2025 Studio 21. All rights reserved.</p>
        </footer>
      </div>
    </div>
  )
}

export default Studio21Home
